import { Link } from "react-router-dom";
// import { BsBarChartLine } from "react-icons/bs";
import { MdStorage } from "react-icons/md";
import {
  FaBolt,
  FaBookOpen,
  FaCrown,
  FaFire,
  FaMedal,
  FaAward,
  // FaCheckCircle,
  // FaClock,
  // FaCalendar,
  // FaUsers,
  // FaExclamationCircle,
  FaTrophy,
  FaStar,
  FaBullseye,
  FaCode,
  FaLayerGroup,
  FaDatabase,
  FaGlobe,
} from "react-icons/fa";
import { FaChartBar, FaArrowRight } from "react-icons/fa";
// import { FaArrowTrendUp } from "react-icons/fa6"; // for trending up icon
import { AiOutlineFileDone } from "react-icons/ai";
import { FaBrain, FaPlay } from "react-icons/fa";
import Button from "../../../../ReusableComponent/Button";
import StatCard from "../../../../ReusableComponent/StatsCard/StatsCard";
import Avatarimg from "../../../../../assets/images/avatar.png";
import { getDaysRemaining } from "../../../../../utils/dateUtils";
import Loader from "../../../../../shared_components/Loader";
import { useEffect } from "react";

const DashboardSections = ({
  quizTestsLeaderboard,
  leaderboardLoading,
  quizTestsList,
  publicQuizzes,
  stats,
  totalcertificates,
  currentUser
}) => {

  // const isLoading =
  //   !quizTestsLeaderboard?.length || !quizTestsList?.length || !stats;
  // if (isLoading) {
  //   return <Loader />;
  // }

  // ✅ Array of card data
  const statItems = [
    {
      value: stats.totalScore,
      label: "Total Points",
      bg: "bg-gradient-primary",
    },
    {
      value: stats.rank,
      label: "Global Rank",
      bg: "bg-success",
    },
    { value: stats.completedTestsCount, label: "Completed", bg: "bg-info" },
    { value: totalcertificates, label: "Certificates", bg: "bg-warning" },
    {
      value: `${stats.totalPassed} / ${stats.totalFailed}`,
      label: "Passed / Failed",
      bg: "bg-danger",
    },
  ];

  const certificates = [
    {
      title: "JavaScript Expert",
      date: "2024-01-15",
      tag: "JavaScript",
    },
    {
      title: "React Developer",
      date: "2024-01-10",
      tag: "React",
    },
    {
      title: "Python Basics",
      date: "2024-01-05",
      tag: "Python",
    },
  ];

  {
    /* Skill-progress and monthly growth */
  }
  const skills = [
    {
      name: "JavaScript",
      percentage: 85,
      color: "warning",
      icon: <FaCode className="text-warning" />,
    },
    {
      name: "React",
      percentage: 78,
      color: "info",
      icon: <FaLayerGroup className="text-info" />,
    },
    {
      name: "Python",
      percentage: 92,
      color: "success",
      icon: <FaDatabase className="text-success" />,
    },
    {
      name: "Node.js",
      percentage: 71,
      color: "primary",
      icon: <FaGlobe className="text-primary" />,
    },
    {
      name: "SQL",
      percentage: 88,
      color: "secondary",
      icon: <MdStorage className="text-secondary" />,
    },
  ];

  const monthlyGoal = {
    percentage: 65,
    completed: 65,
    target: 80,
  };

  // Achievement Section data
  const achievements = [
    {
      title: "Speed Demon",
      rarity: "rare",
      icon: <FaBolt className="text-warning" size={24} />,
      border: "border-outline",
      bg: "bg-outline bg-opacity-10",
      status: true,
    },
    {
      title: "Knowledge Seeker",
      rarity: "common",
      icon: <FaBookOpen className="text-secondary" size={24} />,
      border: "border-secondary",
      bg: "bg-secondary bg-opacity-10",
      status: true,
    },
    {
      title: "Tournament Victor",
      rarity: "legendary",
      icon: <FaCrown className="text-danger" size={24} />,
      border: "border-danger opacity-50",
      bg: "bg-danger bg-opacity-10",
      status: false,
    },
    {
      title: "Streak Master",
      rarity: "epic",
      icon: <FaFire className="text-primary" size={24} />,
      border: "border-primary",
      bg: "bg-primary bg-opacity-10",
      status: true,
    },
    {
      title: "Perfect Score",
      rarity: "rare",
      icon: <FaMedal className="text-info" size={24} />,
      border: "border-info opacity-50",
      bg: "bg-info bg-opacity-10",
      status: false,
    },
  ];

  // Upcoming Exams & Tournaments data
  const exams = [
    {
      title: "JavaScript Advanced Certification",
      level: { label: "Advanced", className: "badge bg-danger" },
      duration: "90 min",
      date: "2024-02-15",
      status: { label: "Registered", className: "badge bg-secondary" },
    },
    {
      title: "React Professional Assessment",
      level: { label: "Expert", className: "badge bg-secondary" },
      duration: "120 min",
      date: "2024-02-20",
      status: { label: "Register", className: "btn btn-outline-light btn-sm" },
    },
    {
      title: "Full Stack Developer Test",
      level: { label: "Professional", className: "badge bg-secondary" },
      duration: "180 min",
      date: "2024-02-25",
      status: { label: "Registered", className: "badge bg-secondary" },
    },
  ];

  const tournaments = [
    {
      title: "Global Coding Championship",
      status: { label: "Registered", className: "badge bg-secondary" },
      participants: "5,000",
      date: "2024-02-10",
      prize: "$10,000",
    },
    {
      title: "AI/ML Challenge",
      status: { label: "Open", className: "badge bg-warning text-dark" },
      participants: "2,500",
      date: "2024-02-18",
      prize: "$5,000",
    },
    {
      title: "Web Dev Sprint",
      status: { label: "Completed", className: "badge bg-secondary" },
      participants: "1,200",
      date: "2024-01-28",
      prize: "$3,000",
      rank: "#8",
    },
  ];

  //Recent activity
  const activities = [
    {
      icon: <FaBullseye className="text-info fs-3" />,
      title: "Advanced React Hooks",
      badge: "95% Score",
      badgeClass: "bg-info text-dark",
      time: "2 hours ago",
    },
    {
      icon: <FaAward className="text-warning fs-3" />,
      title: "JavaScript Expert Certification",
      time: "1 day ago",
    },
    {
      icon: <FaTrophy className="text-primary fs-3" />,
      title: "Registered for Global Championship",
      time: "2 days ago",
    },
    {
      icon: <FaStar className="text-success fs-3" />,
      title: "Earned 'Speed Demon' badge",
      time: "3 days ago",
    },
  ];

  //recommended quizzes
  // Take only first 2 public quizzes
  const visiblePublicQuizzes = publicQuizzes?.slice(0, 2);

  // Merge: 2 public + all invite
  const finalQuizList = [
    ...(visiblePublicQuizzes || []),
    ...(quizTestsList || []),
  ];

  // Quiz test card data
  const totalQuizzes = 5;
  const completedQuizzes = 3;
  const available = 5;
  const bestScore = "95%";
  const progress = (completedQuizzes / totalQuizzes) * 100;

  return (
    <>
      <div className="row mx-0 mt-0 d-flex justify-content-center">
        <Link to="/">
          <Button variant="back">
            <i className="bi bi-arrow-left me-2" />
            Back to Home
          </Button>
        </Link>
        <div className="col-md-8 col-11 px-0">
          <div className="m-0 fs-3 p-3 rounded-3 welcome-section">
            Welcome Back, {currentUser.firstName?.toLowerCase().replace(/^./, c => c.toUpperCase())}
          </div>
          <h1 className="pt-4 mb-0 pb-3 text-white">Dashboard</h1>
          <p className="text-light mb-0">
            Track your progress and continue learning
          </p>
          {/* 4cards */}
          {!quizTestsLeaderboard ||
          quizTestsLeaderboard.length === 0 ||
          !stats ? (
            <Loader />
          ) : (
            <div className="row mx-0 py-5 d-flex justify-content-between">
              {statItems.map((stat, idx) => (
                <StatCard
                  key={idx}
                  value={stat.value}
                  label={stat.label}
                  bg={stat.bg}
                  text={stat.text}
                />
              ))}
            </div>
          )}
          <div className="row mx-0 py-5 d-flex">
            {/* Skill-progress and monthly growth */}
            {/* <div className="col-md-8 col-12 py-5 px-0 px-md-3">
              <div className="card bg-dark border-primary hover-card">
                <div className="card-body p-4 ">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-light fw-bold mb-0 d-flex align-items-center">
                      <BsBarChartLine className="me-2 text-primary" /> Skills
                      Progress
                    </h4>
                    <Button variant="gradient" size="sm">
                      View All
                    </Button>
                  </div>

                  <div className="row mx-0 g-4">
                    {skills.map((skill, idx) => (
                      <div key={idx} className="col-md-6 col-12">
                        <div className="d-flex align-items-center mb-2">
                          <div
                            className={`rounded-2 bg-${skill.color} bg-opacity-10 p-2 me-3`}
                          >
                            {skill.icon}
                          </div>
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="text-light fw-medium">
                                {skill.name}
                              </span>
                              <span className="text-primary fw-bold">
                                {skill.percentage}%
                              </span>
                            </div>
                            <div
                              className="progress mt-1"
                              style={{ height: "6px" }}
                            >
                              <div
                                className={`progress-bar bg-${skill.color}`}
                                style={{ width: `${skill.percentage}%` }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}

            {/* Monthly Goal */}
            {/* <div className="col-md-4 col-12 py-5 px-0 px-md-3 ">
              <div className="card bg-dark border-primary hover-card">
                <div className="card-body p-4 text-center">
                  <h5 className="text-light fw-bold mb-4 d-flex align-items-center justify-content-center">
                    <FaBullseye className="me-2 text-primary" /> Monthly Goal
                  </h5>

                  <div className="mb-4">
                    <div className="position-relative d-inline-block">
                      <svg
                        width="120"
                        height="120"
                        style={{ transform: "rotate(-90deg)" }}
                      >
                        <circle
                          cx="60"
                          cy="60"
                          r="50"
                          fill="none"
                          stroke="#1e293b"
                          strokeWidth="8"
                        />
                        <circle
                          cx="60"
                          cy="60"
                          r="50"
                          fill="none"
                          stroke="url(#gradient)"
                          strokeWidth="8"
                          strokeDasharray={2 * Math.PI * 50}
                          strokeDashoffset={
                            2 *
                            Math.PI *
                            50 *
                            (1 - monthlyGoal.percentage / 100)
                          }
                          style={{ transition: "stroke-dashoffset 0.5s ease" }}
                        />
                        <defs>
                          <linearGradient
                            id="gradient"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="0%"
                          >
                            <stop offset="0%" stopColor="#6366f1" />
                            <stop offset="100%" stopColor="#8b5cf6" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <div className="text-light fw-bold h4">
                          {monthlyGoal.percentage}%
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="text-muted mb-1">
                    {monthlyGoal.completed} of {monthlyGoal.target} hours
                  </p>
                  <p className="text-primary fw-medium">Keep going! 💪</p>
                </div>
              </div>
            </div> */}

            {/* Achievement-section */}
            {/* <div className="col-12 py-5 px-0 px-md-3">
              <div className="card bg-dark border-primary">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-light fw-bold mb-0 d-flex align-items-center">
                      <FaAward className="me-2 text-warning" size={20} />{" "}
                      Achievements & Badges
                    </h4>
                    <Button variant="gradient" size="sm">
                      View All
                    </Button>
                  </div>
                  <div className="row d-flex justify-content-center align-items-center gap-3 align-items-stretch">
                    {achievements.map((ach, index) => (
                      <div
                        key={index}
                        className="col-12 col-md-2 d-flex justify-content-center px-0"
                      >
                        <div className="card text-center bg-secondary bg-opacity-25 hover-card ">
                          <div className="card-body p-3 d-flex flex-column align-items-center justify-content-center">
                            <div
                              className="rounded-circle bg-dark d-flex align-items-center justify-content-center mb-2"
                              style={{ width: "60px", height: "60px" }}
                            >
                              <div className="fs-4 d-flex justify-content-center align-items-center">
                                {ach.icon}
                              </div>
                            </div>
                            <h6
                              className="text-light fw-bold mb-3"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {ach.title}
                            </h6>
                            <span
                              className="badge rounded-pill text-uppercase fw-semibold px-3 py-1"
                              style={{
                                fontSize: "0.7rem",
                                background: "#1e293b", // dark slate bg
                                color: "#60a5fa", // light blue text
                                letterSpacing: "0.5px",
                              }}
                            >
                              {ach.rarity}
                            </span>
                            {ach.completed && (
                              <div className="mt-2">
                                <FaCheckCircle
                                  className="text-success"
                                  size={16}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}

            {/* Upcoming Exams */}
            {/* <div className="col-md-6 col-12 py-5 px-0 px-md-3">
              <div className="card bg-dark border-primary">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-light fw-bold mb-0 d-flex align-items-center">
                      <FaBookOpen className="me-2 text-info" /> Upcoming Exams
                    </h4>
                    <Button variant="gradient" size="sm">
                      View All
                    </Button>
                  </div>
                  {exams.map((exam, i) => (
                    <div
                      key={i}
                      className="border-bottom border-secondary pb-3 mb-3"
                    >
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                          <h6 className="text-light fw-bold mb-1">
                            {exam.title}
                          </h6>
                          <div className="d-flex gap-2 mb-2">
                            <span className={exam.level.className}>
                              {exam.level.label}
                            </span>
                            <span className="badge bg-secondary bg-opacity-50">
                              <FaClock className="me-1" size={12} />
                              {exam.duration}
                            </span>
                          </div>
                          <div className="d-flex align-items-center text-muted">
                            <FaCalendar className="me-1" size={14} />
                            <small>{exam.date}</small>
                          </div>
                        </div>
                        <div>
                          {exam.status.className.includes("btn") ? (
                            <Button variant="gradient" size="sm">
                              {" "}
                              {exam.status.label}
                            </Button>
                          ) : (
                            <span className={exam.status.className}>
                              <FaCheckCircle className="me-1" size={12} />
                              {exam.status.label}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}

            {/* Tournaments */}
            {/* <div className="col-md-6 py-5 px-0 px-md-3">
              <div className="card bg-dark border-primary">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-light fw-bold mb-0 d-flex align-items-center">
                      <FaTrophy className="me-2 text-warning" /> Tournaments
                    </h4>
                    <Button variant="gradient" size="sm">
                      View All
                    </Button>
                  </div>
                  {tournaments.map((t, i) => (
                    <div
                      key={i}
                      className="border-bottom border-secondary pb-3 mb-3"
                    >
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                          <h6 className="text-light fw-bold mb-1">{t.title}</h6>
                          <div className="d-flex gap-2 mb-2">
                            <span className={t.status.className}>
                              {t.status.label === "Open" ? (
                                <FaExclamationCircle
                                  className="me-1"
                                  size={12}
                                />
                              ) : (
                                <FaCheckCircle className="me-1" size={12} />
                              )}
                              {t.status.label}
                            </span>
                            <span className="badge bg-secondary bg-opacity-50">
                              <FaUsers className="me-1" size={12} />
                              {t.participants} participants
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="text-muted">
                              <small>
                                <FaCalendar className="me-1" size={14} />
                                {t.date}
                              </small>
                            </div>
                            <div className="text-warning fw-bold">
                              {t.prize}
                              {t.rank && (
                                <small className="text-muted ms-2">
                                  {t.rank}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}

            {/* recent activity */}
            {/* <div className="col-12 py-5 px-0">
              <div className="card bg-dark text-light border-0 rounded-3">
                <div className="card-body p-4">
               
                  <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                    <h5 className="fw-bold mb-0 d-flex align-items-center">
                      <FaBullseye className="me-2 text-primary" />
                      Recent Activity
                    </h5>
                    <Button variant="gradient" size="sm">
                      View All
                    </Button>
                  </div>

                  <div className="row g-3 mb-4">
                    {activities.map((activity, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="d-flex align-items-start p-3 bg-secondary bg-opacity-25 rounded shadow-sm h-100 hover-card">
                          <div className="me-3">{activity.icon}</div>
                          <div className="flex-grow-1">
                            <h6 className="mb-1 fw-semibold text-light">
                              {activity.title}
                            </h6>
                            {activity.badge && (
                              <span
                                className={`badge rounded-pill ${activity.badgeClass} mb-1`}
                              >
                                {activity.badge}
                              </span>
                            )}
                            <div>
                              <small className="text-muted">
                                {activity.time}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>     */}

            {/* Quiz Test and Assessment Cards */}
            {/* <div className="col-md-8 col-12 py-5 px-0  flex-column flex-md-row align-items-center"> */}
            {/* <div className="row mx-0 px-0 g-4"> */}

            <div className="col-md-6 col-12 pe-lg-4 ps-lg-0 pe-md-4 ps-md-0 pe-2 ps-2">
              <div className="mb-5 d-flex flex-column border border-success rounded-3 bg-card-gradient">
                <div className="p-4 h-100 d-flex flex-column position-relative">
                  {/* Faint background icon */}
                  <div className="position-absolute top-0 end-0 opacity-25 text-secondary">
                    <FaChartBar size={80} />
                  </div>

                  {/* Header section */}
                  <div className="row mx-0 align-items-center mb-4">
                    <div className="col-auto position-relative">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-3"
                        style={{
                          width: "64px",
                          height: "64px",
                          background:
                            "linear-gradient(135deg, rgb(11,244,97), rgb(11,244,11))",
                        }}
                      >
                        <AiOutlineFileDone size={32} className="text-white" />
                      </div>
                      {/* <div className="position-absolute top-0 end-0 badge rounded-pill bg-success">
                      12
                    </div> */}
                    </div>
                    <div className="col">
                      <h3 className="fs-3 fw-bold mb-1 text-white">
                        Assessment
                      </h3>
                      <p className="text-white mb-0">View &amp; Attempt</p>
                    </div>
                  </div>

                  {/* Stats Grid */}
                  <div className="row mx-0 g-3 mb-4 flex-grow-1">
                    {/* <div className="col-6">
                    <div className="bg-secondary bg-opacity-25 rounded p-3">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <FaClock className="text-success" size={16} />
                        <span className="text-uppercase text-light small fw-semibold">
                          Duration
                        </span>
                      </div>
                      <div className="fs-4 fw-bold text-light">45 min</div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="bg-secondary bg-opacity-25 rounded p-3">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <FaUsers className="text-success" size={16} />
                        <span className="text-uppercase text-light small fw-semibold">
                          Active
                        </span>
                      </div>
                      <div className="fs-4 fw-bold text-light">12</div>
                    </div>
                  </div> */}

                    {/* <div className="col-12">
                    <div className="bg-secondary bg-opacity-25 rounded p-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <FaArrowTrendUp className="text-success" size={16} />
                          <span className="text-uppercase text-light small fw-semibold">
                            Success Rate
                          </span>
                        </div>
                        <span className="text-success fw-bold">92%</span>
                      </div>
                      <div className="progress" style={{ height: "8px" }}>
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "92%" }}
                          aria-valuenow="92"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div> */}
                  </div>

                  {/* Button */}
                  {/* <Link to="/assessments" className="text-decoration-none">
                    <button
                      type="button"
                      className="btn btn-success w-100 fw-semibold shadow"
                      style={{
                        background:
                          "linear-gradient(135deg, rgb(11,244,97), rgb(11,244,11))",
                      }}
                    >
                      Start Assessment <FaArrowRight className="ms-2" />
                    </button>
                  </Link> */}
                  {/* Take Quiz Button */}
                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <Link to="/assessments" className="text-decoration-none">
                        <button
                          className="btn btn-success w-100 fw-semibold shadow text-white fw-semibold w-100 d-flex align-items-center justify-content-center gap-2"
                          style={{
                            background:
                              "linear-gradient(135deg, rgb(11,244,97), rgb(11,244,11))",
                          }}
                        >
                          Start Assessment <FaArrowRight />
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 ps-lg-4 pe-lg-0 ps-md-4 pe-md-0 ps-2 pe-2 ">
              <div className="mb-5 d-flex flex-column rounded-3 border border-warning bg-card-gradient">
                <div className="p-4 h-100 d-flex flex-column position-relative ">
                  {/* faded background icon */}
                  <div className="position-absolute top-0 end-0 opacity-25 text-secondary">
                    <FaBrain size={80} />
                  </div>
                  {/* Left icon + title */}
                  <div className="row mx-0 mb-4">
                    <div className="col-auto position-relative">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-3 bg-warning text-white"
                        style={{ width: "64px", height: "64px" }}
                      >
                        <FaBolt size={28} />
                      </div>
                      {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                      {totalQuizzes}
                    </span> */}
                    </div>

                    <div className="col d-flex flex-column justify-content-center">
                      <h3 className="fw-bold mb-1 text-light">Quiz Test</h3>
                      <small className="text-light">Test Your Knowledge</small>
                    </div>
                  </div>

                  {/* Progress */}
                  {/* <div className="row mb-4">
                  <div className="col d-flex justify-content-between mb-2">
                    <small className="text-light">Quiz Progress</small>
                    <small className="fw-medium text-warning">
                      {completedQuizzes} of {totalQuizzes} completed
                    </small>
                  </div>
                  <div className="col-12">
                    <div className="progress" style={{ height: "12px" }}>
                      <div
                        className="progress-bar bg-warning"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div> */}

                  {/* Stats */}
                  {/* <div className="row text-center mb-4">
                  <div className="col-6 mb-3">
                    <div className="bg-secondary bg-opacity-25 p-3 shadow-sm h-100">
                      <div className="d-flex align-items-center justify-content-center mb-2 text-warning">
                        <FaPlay />
                      </div>
                      <small className="text-light d-block">Available</small>
                      <h5 className="fw-bold mb-0 text-warning">{available}</h5>
                    </div>
                  </div>

                  <div className="col-6 mb-3">
                    <div className="bg-secondary bg-opacity-25 p-3 shadow-sm h-100">
                      <div className="d-flex align-items-center justify-content-center mb-2 text-warning">
                        <FaAward />
                      </div>
                      <small className="text-light d-block">Best Score</small>
                      <h5 className="fw-bold text-warning mb-0">{bestScore}</h5>
                    </div>
                  </div>
                </div> */}

                  {/* Take Quiz Button */}
                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <Link to="/quiz/tests" className="text-decoration-none">
                        <button className="btn btn-warning text-white fw-semibold w-100 d-flex align-items-center justify-content-center gap-2">
                          Take Quiz <FaArrowRight />
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 
            </div> */}
            {/* </div> */}

            {/* Recommended Quizzes */}
            <div className="col-12 col-md-6 col-lg-6 pe-lg-4 ps-lg-0 pe-md-4 ps-md-0 pe-2 ps-2">
              <div className="border rounded-3 border-primary h-100">
                <div className="p-4">
                  <h4 className="text-light fw-bold mb-3">
                    Recommended Quizzes
                  </h4>
                  {!quizTestsList ? (
                    <Loader />
                  ) : finalQuizList.length > 0 ? (
                    finalQuizList.map((quiz, idx) => {
                      const daysLeft = getDaysRemaining(quiz.endDate, 15);
                      const showExpiry = getDaysRemaining(
                        quiz.inviteExpDate,
                        7
                      );
                      return (
                        <div
                          key={idx}
                          className="d-flex justify-content-between align-items-center p-3 mb-2 rounded hover-card"
                        >
                          <div>
                            <h6 className="text-light mb-1">
                              {quiz.quizTitle}
                            </h6>
                            {daysLeft && (
                              <span className="badge bg-danger">
                                {daysLeft} day{daysLeft !== 1 && "s"} left to
                                attempt
                              </span>
                            )}
                            {showExpiry && (
                              <span
                                className="mb-2"
                                style={{ color: "orange" }}
                              >
                                Expire in {showExpiry} days
                              </span>
                            )}
                          </div>
                          <Button variant="gradient">Start</Button>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-light">No pending quizzes available</p>
                  )}
                </div>
              </div>
            </div>

            {/* Leaderboard */}
            <div className="col-12 col-md-6 col-lg-6 ps-lg-4 pe-lg-0 ps-md-4 pe-md-0 ps-2 pe-2">
              <div className="rounded-3 border bg-dark-secondary border-primary">
                <div className="p-4">
                  <h4 className="text-light fw-bold mb-3">Leaderboard</h4>
                  {leaderboardLoading ? (
                    <Loader />
                  ) : quizTestsLeaderboard &&
                    quizTestsLeaderboard.length > 0 ? (
                    <div className="invisible-scrollbar">
                      {quizTestsLeaderboard.slice(0, 7).map((lead, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center p-2 mb-2 rounded hover-card bg-card-gradient"
                        >
                          <i
                            className="bi bi-trophy-fill me-2"
                            style={{ color: "#FFD700", fontSize: "1.5rem" }}
                          ></i>
                          <img
                            src={Avatarimg}
                            alt="Avatar"
                            className="rounded-circle me-2"
                            width="24"
                            height="24"
                          />
                          <div className="flex-grow-1">
                            <span className="text-light fw-medium">
                              {lead.name} {lead.lastName}
                            </span>
                          </div>
                          <span className="text-warning fw-bold">
                            {lead.totalScore} pts
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-light">No leaderboard data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Recent Certificates */}
          {/* <div className="col-12 mb-4">
            <div className="rounded-lg border bg-dark-secondary border-primary">
              <div className="p-4">
                <h4 className="text-light fw-bold mb-3">Recent Certificates</h4>
                <div className="row">
                  {certificates.map((cert, index) => (
                    <div key={index} className="col-md-4 mb-3">
                      <div className="card bg-gradient-warning text-dark hover-card">
                        <div className="card-body text-center">
                          <div className="mb-2" style={{ fontSize: "1.5rem" }}>
                            🏆
                          </div>
                          <h6 className="fw-bold mb-1">{cert.title}</h6>
                          <small className="opacity-75 d-block mb-2">
                            {cert.date}
                          </small>
                          <div className="mt-2">
                            <span className="badge bg-dark">{cert.tag}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default DashboardSections;
